// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"eee86631","632":"e82b9854"}[chunkId] + ".chunk.js";
};